// extracted by mini-css-extract-plugin
export default {"loading_view":"Modal_loading_view__Rn1tU","loading_img":"Modal_loading_img__6p9OL","loading":"Modal_loading__rFeoI","text":"Modal_text__xio0Q"};